import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 企业列表查询接口，rows表示每页行数，最大10
 * @param account
 * @param password
 * @return {*}
 */
export function apiCompanyList (params) {
  if (params.areaCode === '不限') {
    params.areaCode = 0
  }
  return doHttp('/company/v1/getCompanyList', HTTP_TYPE_POST, params)
}

/**
 * 企业详情查询接口
 * @param params
 * @returns {*}
 */
export function apiCompanyDetail (companyKey) {
  let params = { companyKey }
  return doHttp('/company/v1/getCompanyDetail', HTTP_TYPE_POST, params)
}

/**
 * 获取企业已关联的用户列表接口
 * @param companyKey
 * @returns {*}
 */
export function apiUserCompanyList (companyKey) {
  let params = { companyKey }
  return doHttp('/company/v1/getUserCompanyList', HTTP_TYPE_POST, params)
}

/**
 * 获取企业用户详情接口，参数中，id传入userId（用户id）
 * @param id
 * @returns {*}
 */
export function apiUserCompanyDetail (id) {
  let params = { id }
  return doHttp('/company/v1/getUserCompanyDetail', HTTP_TYPE_POST, params)
}

/**
 * 更新企业用户信息接口
 * @param params
 * @returns {*}
 */
export function apiUpdateUserCompany (params) {
  return doHttp('/company/v1/authApi/updateUserCompany', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/company.js